'use strict';

app.directive('rmUserDateYear', function () {
  return {
    require: ['^rmUserDate', 'ngModel'],
    link: function (scope, element, attr, ctrls) {
      ctrls[0].addYear(ctrls[1]);
    }
  };
});
app.directive('rmUserDateMonth', function () {
  return {
    require: ['^rmUserDate', 'ngModel'],
    link: function (scope, element, attr, ctrls) {
      ctrls[0].addMonth(ctrls[1]);
    }
  };
});
app.directive('rmUserDate', function () {
  return {
    require: ['^form', 'ngModel'],
    scope: true,
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl  = ctrls[0];
      scope.modelCtrl = ctrls[1];
    },
    controller: function ($scope, $attrs) {
      this.addMonth = function (model) {
        this.month = model;
      };
      this.addYear = function (model) {
        this.year = model;
      };
      var self = this;
      var validate = function () {
        //should accept the year + month, and and year without month
        if (_.isNull(self.month.$modelValue) && _.isNull(self.month.$modelValue)) {
          self.year.$setValidity('rmUserDate', true);
          self.month.$setValidity('rmUserDate', true);
        } else {
          var dateIsDefined = (!_.isNull(self.year.$modelValue) && !_.isNull(self.month.$modelValue) || !_.isNull(self.year.$modelValue));
          self.year.$setValidity('rmUserDate', dateIsDefined);
          self.month.$setValidity('rmUserDate', dateIsDefined);
        }
        if ($attrs.lessThan && $scope.modelCtrl.$modelValue.year && $scope.formCtrl[$attrs.lessThan].$modelValue.year) {
          var lessThan = new Date($scope.formCtrl[$attrs.lessThan].$modelValue.year, $scope.formCtrl[$attrs.lessThan].$modelValue.month);
          var date = new Date($scope.modelCtrl.$modelValue.year, $scope.modelCtrl.$modelValue.month);
          self.year.$setValidity('rmUserDateLessThan',  date < lessThan);
          self.month.$setValidity('rmUserDateLessThan', _.isNull(self.month.$modelValue) ? true : date < lessThan);
        } else {
          self.year.$setValidity('rmUserDateLessThan',  true);
          self.month.$setValidity('rmUserDateLessThan', true);
        }
      };
      $scope.$watch(function () {
        return (self.year ? self.year.$modelValue : '') + '' + (self.month ? self.month.$modelValue : '');
      }, validate, true);
      if ($attrs.lessThan) {
        $scope.$watch(function () {
          return $scope.formCtrl[$attrs.lessThan].$modelValue.year ? $scope.formCtrl[$attrs.lessThan].$modelValue : '';
        }, validate, true);
      }
    }
  };
});
